import {
  useContext,
  useState,
  Fragment,
  useEffect,
  useCallback,
  memo,
} from "react";

import classes from "./SearchCard.module.css";

import SelectIngredients from "../SelectIngredients/SelectIngredients";
import SearchWindow from "../SearchWindow/SearchWindow";
import SearchActions from "../SearchActions/SearchActions";
import SearchResultsCard from "../../SearchResultsCard/SearchResultsCard";
import LoadingSpinner from "../../../UI/LoadingSpinner";

import SearchContext from "../../../store/search-context";

import { useHttpClient } from "../../../hooks/http-hook";

// component allows user to search database of cocktails bases on input ingredients
const SearchCard = (props) => {
  const searchCtx = useContext(SearchContext);

  const [loadedCocktails, setLoadedCocktails] = useState([]);
  const [showResultsCard, setShowResultsCard] = useState(false);

  // hook to load cocktails from backend
  const { sendRequest, isLoading } = useHttpClient();

  // display results once they have been fetched
  const showResultsCardHandler = useCallback(() => {
    setShowResultsCard(true);
  }, []);

  const hideResultsCardHandler = useCallback(() => { 
    setLoadedCocktails([]);
    setShowResultsCard(false);
  }, []);

  const fetchCocktailsHandler = () => {
    if(searchCtx.items.length > 0){
      fetchCocktails();
    }
  }

  // Loading list of drinks from backend
  const fetchCocktails = useCallback(async () => {
    
    //make sure default setting when colour coding ingredient in expanded bar view is comparing to search rather than to cabinet
    searchCtx.setCompareToCabinet(false)

    // get all id's of ingredients in search bar
    let ingIDs = [];
    searchCtx.items.forEach((item) => {
      ingIDs.push(item.id);
    });

    // use id's to fetch cocktails from backend
    try {
      const responseData = await sendRequest(
        `${process.env.REACT_APP_BACKEND_URL}/cocktails/getAllCocktailsContainingAnyIngredient`,
        "POST",
        JSON.stringify({ ingredients: ingIDs }),
        { "Content-Type": "application/json" }
      );
      setLoadedCocktails(responseData.cocktails);
    } catch (err) {
    }
  }, [searchCtx.items, sendRequest, isLoading]);

  //only display cocktails once they have been received
  useEffect(() => {
    if (loadedCocktails.length > 0) {
      showResultsCardHandler();
    }
  });

  return (
    <Fragment>
      {showResultsCard && (
        <SearchResultsCard
          drinks={loadedCocktails}
          onClose={hideResultsCardHandler}
          isSearchQuery={true}
        />
      )}
      {isLoading && <LoadingSpinner asOverlay />}
      <div className={classes.search_card}>
        <div class={classes.header}>
          <SearchWindow items={searchCtx.items} />
        </div>
        <div className={classes.body}>
          <SelectIngredients />
        </div>
        <div className={classes.footer}>
          <SearchActions onSearch={fetchCocktailsHandler} />
        </div>
      </div>
    </Fragment>
  );
};

export default memo(SearchCard);
